export default "__VITE_ASSET__f64bfbfb__"